//员工接口

import request from '../request';


//分页查询
export const reqGetPageData = (page, pageSize) => request({ url:`/admin/employee/page/${page}/${pageSize}`, method:'get' });

//新增
export const reqAddData = (data) => request({ url:'/admin/employee/save', method:'post', data });

//修改
export const reqUpdateData = (data) => request({ url:'/admin/employee/update', method:'put', data });

//调整状态
export const reqUpdateStatus = (status, id) => request({ url:`/admin/employee/status/${status}/${id}`, method:'post' });

//根据姓名查询
export const reqQueryData = (name) => request({ url:`/admin/employee/name/${name}`, method:'get' });

//登录
export const reqLogin = (data) => request({ url:'/admin/employee/login', method:'post', data:data });

//登出
export const reqLogout = () => request({ url:'/admin/employee/logout', method:'post' });
